import orderInstance from '../instance'

const registerOrder = (orderId) => {
	return orderInstance.post('/orders/' + orderId + '/register', {})
}

export default registerOrder
